import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { ReactComponent as Action } from "../static/Icons/actions.svg";
import { ReactComponent as Test } from "../static/Icons/test.svg";
import { ReactComponent as History } from "../static/Icons/history.svg";
import { ReactComponent as Delete } from "../static/Icons/trash.svg";
import { ReactComponent as Google } from "../static/Icons/google.svg";
import {
  connectTool,
  // connectTool,
  deleteToolById,
} from "../api/tool";
import { showErrorToast, showSuccessToast } from "../toastUtils";
import { getServerById, addActionInServer } from "../api/server";
import CommonModal from "../CommonComponents/CommonModal";
import ButtonCommon from "../CommonComponents/ButtonCommon";
import { useParams } from "react-router-dom";

export default function ToolsPage({
  serverDetails,
  setServerDetails,
  setSelectedTab,
  setToolActionData,
  setFilterValue,
  setInitialFilterValue,
  // setOpenModal,
  oauthState,
}) {
  // const { divHeight } = useContext(RightSideContainer);

  const [allTools, setAllTools] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteToolId, setDeleteToolId] = useState(null);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const { id } = useParams();
  const [finalConnectModal, setFinalConnectModal] = useState(false);
  const [selectedTool, setSelectedTool] = useState(null);
  const [loading, setLoading] = useState(false);
  const [oauthMethod, setOauthMethod] = useState("");
  const [personalAccessToken, setPersonalAccessToken] = useState("");
  const [tokenError, setTokenError] = useState("");
  const [isAuthCompleted, setIsAuthCompleted] = useState(false);
  const [authStatus, setAuthStatus] = useState("");

  const [storedData, setstoreData] = useState(null);

  useEffect(() => {
    setAllTools(serverDetails.actions);
  }, [serverDetails]);


  console.log("all Tools", allTools);

  const formatLabel = (text) => {
    if (!text) return "";
    return text
      .split("_")
      .map((word) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  };

  const deleteTool = async (toolId) => {
    setDeleteLoader(true);
    try {
      const res = await deleteToolById(toolId);
      if (res.success) {
        const serverId = localStorage.getItem("server_id");

        const resData = await getServerById(serverId);
        setServerDetails(resData.data);
        setAllTools(resData.data.actions);
        showSuccessToast(res.messsage);
      } else {
        showErrorToast(res.messsage);
      }
    } catch (error) {
      console.error("Error deleting tool:", error);
      showErrorToast(error?.messsage);
    } finally {
      setOpenDeleteModal(false);
      setDeleteLoader(false);
      setDeleteToolId(null);
    }
  };

  const handleToolConnect = async (method, provider) => {
    setLoading(true);
    setAuthStatus("");
    try {
      const payload = {
        provider: provider?.toolName,
        scopes: Array.isArray(provider?.authScope)
          ? provider.authScope.join(",")
          : "",
        redirect: `${window.location.origin}/dashboard/oauth/callback`,
        auth_method: method,
      };

      if (method === "personal_access_token") {
        payload.access_token = personalAccessToken;
        payload.server_url = null; // Add server_url field for PAT authentication
      }

      const res = await connectTool(payload);

      if (method === "personal_access_token") {
        // Handle PAT authentication response
        if (res?.success) {
          setIsAuthCompleted(true);
          setAuthStatus("Connect Successful");
          showSuccessToast(
            res?.message || "Personal Access Token authenticated successfully"
          );
        } else {
          setIsAuthCompleted(false);
          setAuthStatus("Connection Failed");
          showErrorToast(res?.message || "Authentication failed");
        }
      } else if (res?.data?.auth_url) {
        // Handle OAuth flow
        localStorage.setItem("oauthResponse", JSON.stringify(res));
        sessionStorage.setItem(
          "postOAuthModalState",
          JSON.stringify(storedData)
        );
        window.location.href = res.data.auth_url;
      } else {
        setIsAuthCompleted(false);
        setAuthStatus("Connection Failed");
        showErrorToast(res?.message || "Authentication failed");
      }
    } catch (err) {
      setIsAuthCompleted(false);
      setAuthStatus("Connection Failed");
      showErrorToast(err?.message || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    const selectedMethod = event.target.value;
    setOauthMethod(selectedMethod);

    // If not personal token, call API immediately
    if (selectedMethod !== "personal_access_token") {
      handleToolConnect(selectedMethod, selectedTool);
    }
  };

  const handleTokenSubmit = () => {
    if (!personalAccessToken.trim()) {
      setTokenError("Access token is required");
      return;
    }
    setTokenError("");
    handleToolConnect("personal_access_token", selectedTool);
  };

  const handleClickTool = (action, tool) => {
    switch (action) {
      case Action: {
        setSelectedTab(1);

        // Update toolActionData
        const toolActions = tool.toolActions.map((toolAction) => ({
          ...toolAction,
          toolAuth: tool.toolAuth,
          toolIcon: tool.toolIcon,
          toolName: tool.toolName,
          authOptions: tool.authOptions,
        }));

        setToolActionData({ toolActions });

        // Update filterValue to include ONLY this tool and its actions
        setFilterValue({
          tool: [tool.toolId],
          action: tool.toolActions.map((a) => a.actionId),
        });
        setInitialFilterValue({
          tool: [tool.toolId],
          action: tool.toolActions.map((a) => a.actionId),
        });

        break;
      }

      case Test:
        setSelectedTab(2);
        break;

      case History:
        setSelectedTab(4);
        break;

      case Delete:
        setOpenDeleteModal(true);
        setDeleteToolId(tool.toolId);
        break;

      default:
        console.log("Unknown action");
    }
  };

  // Helper for dynamic icon rendering (copy from ServerDetails.js for consistency)
  const renderToolIcon = (tool, size = 42) => {
    if (tool && tool.toolIcon) {
      try {
        return (
          <img
            src={require(`../static/Icons/${tool.toolIcon}`)}
            alt={tool.toolName}
            style={{
              width: size,
              height: size,
              objectFit: "contain",
              borderRadius: 8,
            }}
          />
        );
      } catch (e) {
        // fallback if icon not found
        try {
          return (
            <img
              src={require(`../static/Icons/default-tool.svg`)}
              alt="default-tool"
              style={{
                width: size,
                height: size,
                objectFit: "contain",
                borderRadius: 8,
              }}
            />
          );
        } catch (e2) {
          return <Google style={{ width: size, height: size }} />;
        }
      }
    }
    // fallback if toolIcon is missing
    try {
      return (
        <img
          src={require(`../static/Icons/default-tool.svg`)}
          alt="default-tool"
          style={{
            width: size,
            height: size,
            objectFit: "contain",
            borderRadius: 8,
          }}
        />
      );
    } catch (e) {
      return <Google style={{ width: size, height: size }} />;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        justifyContent: { xs: "center", sm: "flex-start" },
        width: "100%",
        height: "100%",
      }}
    >
      {allTools &&
        allTools.length > 0 &&
        allTools.map((tool) => (
          <Box
            key={tool?.tool_id}
            sx={{
              flex: "1 1 270px",
              maxWidth: "350px",
              bgcolor: tool.toolAuth === "false" ? "#FFC9C633" : "#D4E6FF17",
              borderRadius: "6px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {console.log(tool)}
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 1, p: 2 }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 42,
                    height: 42,
                    bgcolor: "#C7D3EA1F",
                  }}
                >
                  {renderToolIcon(tool, 30)}
                </Box>
                <Typography
                  sx={{
                    color: "#D7D7D7",
                    fontWeight: "bold",
                    fontSize: 16,
                    textTransform: "capitalize",
                  }}
                >
                  {tool?.toolName}
                </Typography>
              </Box>
              <Typography
                sx={{ fontSize: 12, color: "#C3C3C3", minHeight: "40px" }}
              >
                {tool?.toolDescription}
              </Typography>
            </Box>

            <Divider sx={{ bgcolor: "#4A4A4A" }} />

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                p: 0.5,
                gap: 1,
                flexShrink: 0, // 🔑 prevents this section from growing vertically
              }}
            >
              {[Action, Test, History, Delete].map((Icon, i) => (
                <IconButton
                  key={i}
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    color: "#B2B2B2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                    "&:hover": {
                      bgcolor: "#2C2C2C",
                      color: "#FFFFFF",
                    },
                  }}
                  onClick={() => handleClickTool(Icon, tool)}
                >
                  <Box component={Icon} sx={{ width: 20, height: 20 }} />
                </IconButton>
              ))}
            </Box>

            {tool.toolAuth === "false" &&  (
              <Box sx={{ p: 2, pt: 1 }}>
                <ButtonCommon
                  onClick={() => {
                    setSelectedTool(tool);
                    setFinalConnectModal(true);
                    setstoreData({
                      tool: tool,
                      selectedActions: tool.toolActions,
                      isBulkAdd: tool.toolActions.length > 1 ? true : false,
                      returnTo: `/dashboard/server/${id}`,
                    });
                  }}
                  variant="contained"
                  fullWidth
                  size="small"
                  sx={{ textTransform: "none" }}
                >
                  Finish Setup
                </ButtonCommon>
              </Box>
            )}
          </Box>
        ))}

      <CommonModal
        open={finalConnectModal}
        handleClose={() => {
          setFinalConnectModal(false);
          setOauthMethod("");
          setPersonalAccessToken("");
          setTokenError("");
          setIsAuthCompleted(false);
          setAuthStatus("");
        }}
        title={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 30,
                height: 30,
                bgcolor: "#00000038",
                p: 0.7,
                borderRadius: 1,
              }}
            >
              {renderToolIcon(selectedTool, 30)}
            </Box>
            <Typography sx={{ color: "white", textTransform: "capitalize" }}>
              {selectedTool?.toolName}
            </Typography>
          </Box>
        }
        cancelText="Cancel"
        cancelProps={{
          onClick: () => {
            setFinalConnectModal(false);
            setOauthMethod("");
            setPersonalAccessToken("");
            setTokenError("");
            setIsAuthCompleted(false);
            setAuthStatus("");
          },
        }}
        submitText={isAuthCompleted ? "Save" : ""}
        submitProps={{
          sx: {
            display: isAuthCompleted ? "flex" : "none",
          },
          disabled: !isAuthCompleted,
          onClick: async () => {
            try {
              const serverId = localStorage.getItem("server_id");
              
              // Update toolAuth status in backend
              const authUpdatePayload = {
                server_id: serverId,
                actions_data: {
                  toolId: selectedTool.toolId,
                  toolName: selectedTool.toolName,
                  toolDescription: selectedTool.toolDescription,
                  toolIcon: selectedTool.toolIcon,
                  toolActions: selectedTool.toolActions || [],
                  toolAuth: "true", // Update auth status to true
                  authOptions: selectedTool.authOptions,
                },
              };
              
              await addActionInServer(authUpdatePayload);
              
              // Refresh server details to show updated auth status
              const resData = await getServerById(serverId);
              setServerDetails(resData.data);
              setAllTools(resData.data.actions);

              setFinalConnectModal(false);
              showSuccessToast("Tool authentication saved successfully");

              // Reset states
              setOauthMethod("");
              setPersonalAccessToken("");
              setTokenError("");
              setIsAuthCompleted(false);
              setAuthStatus("");
            } catch (error) {
              console.error("Error saving tool authentication:", error);
              showErrorToast("Failed to save authentication");
            }
          },
        }}
      >
        <Box variant="outlined">
          <Box>
            <Typography sx={{ color: "#ECECEC", mb: 1 }}>
              GitHub account
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <Box
                key={selectedTool?.toolId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0px",
                  padding: "10px",
                  cursor: "pointer",
                  background: "#2C2F3366",
                  border: "1px solid #50505030",
                  borderRadius: 2,
                }}
              >
                <ListItemIcon>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 30,
                      height: 30,
                      bgcolor: "#2C2F3366",
                      borderRadius: 1,
                      p: 0.7,
                    }}
                  >
                    {renderToolIcon(selectedTool, 30)}
                  </Box>
                </ListItemIcon>
                <ListItemText
                  primary={selectedTool?.toolName}
                  sx={{
                    margin: 0,
                    "& .MuiTypography-root": {
                      color: "white",
                      fontSize: "0.95rem",
                      fontWeight: 400,
                    },
                    textTransform: "capitalize",
                  }}
                />

                {/* <ButtonCommon
                    variant="contained"
                    sx={{
                      width: "fit-content",
                      height: "fit-content",
                      p: 0,
                      px: 1,
                    }}
                   
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={20} /> : "Connect"}
                  </ButtonCommon> */}

                {loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      minWidth: 150, // optional, based on layout
                      marginLeft: "auto", // optional, if you want to push it right
                    }}
                  >
                    <FormControl
                      sx={{
                        "& .MuiInputLabel-root": {
                          color: "white",
                        },
                        "& .MuiOutlinedInput-root": {
                          color: "white",
                          "& fieldset": {
                            borderColor: "primary.main",
                          },
                          "&:hover fieldset": {
                            borderColor: "primary.dark",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "primary.main",
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "white",
                        },
                      }}
                    >
                      <InputLabel id="auth-method-label">
                        Auth Option
                      </InputLabel>
                      <Select
                        labelId="auth-method-label"
                        value={oauthMethod}
                        label="Auth Option"
                        onChange={handleChange}
                      >
                        {selectedTool?.authOptions.map((item) => (
                          <MenuItem key={item} value={item}>
                            {formatLabel(item)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Box>

              {/* Authentication Status Message */}
              {authStatus && (
                <Box
                  sx={{
                    mt: 2,
                    p: 1,
                    borderRadius: 1,
                    backgroundColor: isAuthCompleted
                      ? "#4CAF5020"
                      : "#f4433620",
                    border: `1px solid ${
                      isAuthCompleted ? "#4CAF50" : "#f44336"
                    }`,
                  }}
                >
                  <Typography
                    sx={{
                      color: isAuthCompleted ? "#4CAF50" : "#f44336",
                      fontSize: "0.875rem",
                      fontWeight: 500,
                    }}
                  >
                    {authStatus}
                  </Typography>
                </Box>
              )}

              <Box>
                {oauthMethod === "personal_access_token" && (
                  <Box display={"flex"} alignItems={"center"} gap={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Enter Personal Access Token"
                      variant="outlined"
                      value={personalAccessToken}
                      onChange={(e) => {
                        setPersonalAccessToken(e.target.value);
                        if (tokenError) setTokenError("");
                      }}
                      // onBlur={handleTokenSubmit}
                      error={!!tokenError}
                      helperText={tokenError}
                      sx={{
                        input: { color: "white" },
                        "& label": { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "primary.main" },
                          "&:hover fieldset": {
                            borderColor: "primary.dark",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "primary.main",
                          },
                        },
                      }}
                    />
                    <ButtonCommon
                      variant="contained"
                      sx={{
                        width: "fit-content",
                        height: "fit-content",
                        p: 0,
                        px: 1,
                        backgroundColor: isAuthCompleted
                          ? "#4CAF50"
                          : undefined,
                        "&:hover": {
                          backgroundColor: isAuthCompleted
                            ? "#45a049"
                            : undefined,
                        },
                      }}
                      onClick={handleTokenSubmit}
                      disabled={loading || isAuthCompleted}
                    >
                      {loading ? (
                        <CircularProgress size={20} />
                      ) : (
                        authStatus || "Connect"
                      )}
                    </ButtonCommon>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </CommonModal>

      {/* Delete Confirm Modal */}
      <CommonModal
        open={openDeleteModal}
        // setOpen={setOpenDeleteModal}
        handleClose={() => {
          setOpenDeleteModal(false);
        }}
        title="Delete Tool"
        cancelText="Cancel"
        cancelProps={{
          variant: "outlined",
          onClick: () => {
            setOpenDeleteModal(false);
          },
          sx: { color: "#fff", borderColor: "#fff" },
        }}
        submitText={deleteLoader ? "Deleting..." : "Delete"}
        submitProps={{
          disabled: deleteLoader,
          variant: "contained",
          onClick: () => deleteTool(deleteToolId),
          sx: {
            ...(deleteLoader && {
              backgroundColor: "#999", // custom background
              color: "#fff", // custom text color
              "&.Mui-disabled": {
                backgroundColor: "#999",
                color: "#fff",
              },
            }),
          },
        }}
      >
        <Box variant="outlined">
          <Typography variant="body1" color="white" sx={{ mb: 2 }}>
            Are you sure you want to delete this tool?
          </Typography>
        </Box>
      </CommonModal>
    </Box>
  );
}
